var map = {
	"./Atención al cliente.png": "58c3",
	"./Back Office.png": "1ee7",
	"./Bilingüe.png": "4a6c",
	"./Cobranzas.png": "ddf3",
	"./Crosselling.png": "61e9",
	"./Retenciones.png": "e928",
	"./Social Media.png": "60b7",
	"./Ventas.png": "a6b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "553a2";